import {
  FormatListBulletedIcon,
  LockIcon,
  QuestionOutlinedIcon,
} from '@weblite/icons'
import { styled } from '@mui/material'
import { OptionWithTextItem } from '$common/option-with-text-item'
import { t } from '$i18n'
import { Switch } from '$common/switch'
import { COURSE_VITRINE_TAG, ISSUE_TAG } from '$logic/hall/react-hook'
import { ComingSoon } from '$common/badge'

export function HallAdvancedSettingsOptions({
  vitrineEnabled,
  issueEnabled,
  protectContent,
  setProtectContent,
  toggleTag,
}: {
  vitrineEnabled: boolean
  issueEnabled: boolean
  protectContent: boolean
  setProtectContent: (protectContent: boolean) => void
  toggleTag: (tag: string) => void
}) {
  return (
    <>
      <StyledOption
        primaryIcon={
          <FormatListBulletedIcon
            sx={{ alignSelf: 'start', color: 'primary500' }}
          />
        }
        primaryText={t('createEducationalChannel.vitrine.title')}
        secondaryText={t('createEducationalChannel.vitrine.description')}
        icon={<Switch checked={vitrineEnabled} disabled={false} />}
        onClick={() => toggleTag(COURSE_VITRINE_TAG)}
      />

      <StyledOption
        primaryIcon={
          <QuestionOutlinedIcon
            sx={{ alignSelf: 'start', color: 'primary500' }}
          />
        }
        primaryText={t('createEducationalChannel.issue.title')}
        secondaryText={t('createEducationalChannel.issue.description')}
        icon={<Switch checked={issueEnabled} />}
        onClick={() => toggleTag(ISSUE_TAG)}
      />

      <StyledOption
        primaryIcon={
          <LockIcon sx={{ alignSelf: 'start', color: 'primary500' }} />
        }
        primaryText={t('hallAdvancedSettings.protectContent.title')}
        secondaryText={t('hallAdvancedSettings.protectContent.description')}
        primaryTextColor="neutral1000"
        primaryTextVariant="body2"
        secondaryTextColor="neutral600"
        secondaryTextVariant="caption1"
        icon={<Switch checked={protectContent} />}
        onClick={() => setProtectContent(!protectContent)}
      />
    </>
  )
}

const StyledOption = styled(OptionWithTextItem)`
  height: 80px;
`
